// extracted by mini-css-extract-plugin
module.exports = {"background":"bc_dV","shopping__wrapper__examples":"bc_fj","active":"bc_fk","shopping__wrapper__project":"bc_fl"};